import React from 'react';
import { Box, Slider } from '@mui/material';
export default function SingleSliderThree({ value, setValues }) {
  const handleChange = (e) => {
    setValues({ ...value, value1: e.target.value, altered: true });
  };
  const handleChange2 = (e) => {
    setValues({ ...value, value2: e.target.value, altered2: true });
  };
  return (
    <div className="slider-conti slider-conti-f">
      <div
        className="sliderNumber sliderNumber3"
        style={{
          backgroundColor: value.altered && value.altered2 ? '#92D2C4' : '#fff',
          color: value.altered && value.altered2 ? '#fff' : '#000',
        }}
      >
        {value.id}
      </div>
      <div className="sliderMain">
        <div className="slider-name-container">
          {value?.name + ' Wellbeing'}
        </div>
        <div className="slider-container-c">
          <div className="slider-title">{value.question1}</div>
          <div className="slider-image slider-image-three">
            <Box>
              <Slider
                onChange={(e) => handleChange(e, value.value1)}
                value={value.value1}
                aria-label="Disabled slider"
                sx={{
                  '& .css-7drnjp::after': {
                    backgroundColor: '#92D2C4',
                    backgroundSize: 'contain',
                    // content: `"${value?.value1}"`,
                    content: '""',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    objectFit: 'cover',
                    backgroundPosition: 'center',
                  },
                }}
              />
            </Box>
            <div className="sliderHelper sliderHelper-three">
              <div className={`${value.value1 < 21 ? 'inRange' : 'outranage'}`}>
                I'm really struggling
              </div>
              <div
                className={`${
                  value.value1 > 20 && value.value1 < 41
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                {' '}
                I'm starting to struggle
              </div>
              <div
                className={`${
                  value.value1 > 40 && value.value1 < 61
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                I need some advice
              </div>
              <div
                className={`${
                  value.value1 > 60 && value.value1 < 81
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                I'm OK at the moment
              </div>
              <div className={`${value.value1 > 80 ? 'inRange' : 'outranage'}`}>
                Very comfortable
              </div>
            </div>
          </div>
        </div>
        <div className="slider-container-c">
          <div className="slider-title">{value.question2}</div>
          <div className="slider-image slider-image-three">
            <Box>
              <Slider
                onChange={(e) => handleChange2(e, value.value2)}
                value={value.value2}
                aria-label="Disabled slider"
                sx={{
                  '& .css-7drnjp::after': {
                    backgroundColor: '#92D2C4',
                    backgroundSize: 'contain',
                    // content: `"${value?.value2}"`,
                    content: '""',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    objectFit: 'cover',
                    backgroundPosition: 'center',
                  },
                }}
              />
            </Box>
            <div className="sliderHelper sliderHelper-three">
              <div className={`${value.value2 < 21 ? 'inRange' : 'outranage'}`}>
                There is no support
              </div>
              <div
                className={`${
                  value.value2 > 20 && value.value2 < 41
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                I'm not aware of any support
              </div>
              <div
                className={`${
                  value.value2 > 40 && value.value2 < 61
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                I think there's help there
              </div>
              <div
                className={`${
                  value.value2 > 60 && value.value2 < 81
                    ? 'inRange'
                    : 'outranage'
                }`}
              >
                We have some support
              </div>
              <div className={`${value.value2 > 80 ? 'inRange' : 'outranage'}`}>
                We are fully supported
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
